module.exports = __webpack_public_path__ + "img/07_choice 4.50d5094a.png";